export default __webpack_public_path__ + "static/media/hair-1-2.b17cf5be.svg";